import React, { useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { GicAnywhere } from '@atlassian/gic-anywhere';

import { fg } from '@confluence/feature-gating';
import { useSessionData } from '@confluence/session-data';

import type { GicPanelBodyProps } from '../../__types__/GicPanelBody';
import { getPersistedOverrideCloudId } from '../../utils/localStorageHelpers';
import { useIssueCreateSidePanelContext } from '../../providers/IssueCreateSidePanelContextProvider';
import { SingleWorkCreateForm } from '../single-work-create-form/SingleWorkCreateForm';
const noop = () => {};

export const GicPanelBody = ({
	onClose,
	onSuccess,
	onFailure,
	analyticsSource,
	summary,
	descriptionAdf,
	isCreatedWithAi,
	isCreatedFromTable,
	issueTypeId,
	projectId,
	configuration,
	cloudId,
}: GicPanelBodyProps) => {
	const { cloudId: sessionCloudId } = useSessionData();

	const { createAnalyticsEvent } = useAnalyticsEvents();
	const [{ pageMode, hasEditPermission }] = useIssueCreateSidePanelContext();

	const persistedOverrideCloudId = getPersistedOverrideCloudId();

	const overrideCloudIdForSitePicker =
		persistedOverrideCloudId !== sessionCloudId ? persistedOverrideCloudId : undefined;

	const currentCloudId = overrideCloudIdForSitePicker || cloudId;

	useEffect(() => {
		createAnalyticsEvent({
			type: 'sendScreenEvent',
			data: {
				name: 'linkCreateScreen',
				attributes: {
					isManuallyCreated: !isCreatedWithAi,
					isCreatedWithAi,
					isCreatedFromTable,
					pageMode,
					hasEditPermission,
				},
				source: analyticsSource,
			},
		}).fire();
	}, [
		isCreatedWithAi,
		isCreatedFromTable,
		createAnalyticsEvent,
		analyticsSource,
		pageMode,
		hasEditPermission,
	]);

	if (fg('jira_ai_decouple_issue_create_fields')) {
		return <SingleWorkCreateForm closePanel={onClose} />;
	}

	return (
		<GicAnywhere
			cloudId={currentCloudId}
			consumer="confluence-highlight-issue-create"
			onInit={noop}
			onSuccess={onSuccess}
			onClose={onClose}
			onFailure={onFailure}
			summary={summary}
			descriptionAdf={descriptionAdf}
			overrideCloudId={overrideCloudIdForSitePicker}
			issueTypeId={issueTypeId}
			projectId={projectId}
			isPayloadReady
			configuration={configuration}
		/>
	);
};
